import { render, staticRenderFns } from "./PayrollListItem.vue?vue&type=template&id=2b78c2cd&"
import script from "./PayrollListItem.vue?vue&type=script&lang=js&"
export * from "./PayrollListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports